import React, {useEffect} from 'react';
import {uploadShopifyCollectionImage} from "../../../common/services/cloud-function-service";
import {SHOPIFY_COLLECTION_IMAGES_PATH} from "../../constants/shopify.constant";
import {THUMB_PREFIX} from "../../../design/constants/design.constant";
import {uploadSingleImageFile} from "../../services/shopify-product-file-data-service";
import {getImageDownloadUrlFromFullPath} from "../../../common/utils/image-util";
import _ from "lodash";

const UpdateShopifyCollectionImage = ({
                                          imageBase64,
                                          collection,
                                          setSaveInProgress,
                                          currentStageRef,
                                          currentStageScale
                                      }) => {
    // const [imageData, setImageData] = React.useState(null);

    /*useEffect(() => {
        console.log('Image Changed');
        setImageData(imageBase64);
    }, [imageBase64]);*/

    const uploadCollectionImage = async () => {
        setSaveInProgress(true);
        const imageFileName = collection.handle + '-' + collection.id + '.jpg';

        // const collectionImageFileName = collection.handle;
        const filePath = [];
        filePath.push(_.kebabCase(SHOPIFY_COLLECTION_IMAGES_PATH));
        // filePath.push(_.kebabCase(collection.handle || ''));
        filePath.push(imageFileName);
        // filePath.push(THUMB_PREFIX + collectionImageFileName + '.jpg');
        const fullFilePath = _.join(_.compact(filePath), '/');

        const metaData = {
            contentType: "image/jpg",
        };

        const pixelRatio = 100 / (currentStageScale * 100);
        const imageData = currentStageRef.current.toDataURL({
            pixelRatio: pixelRatio,
        });

        const result = await uploadSingleImageFile(fullFilePath, imageData, metaData);
        const imageDetail: any = result.metadata;

        await getImageDownloadUrlFromFullPath(imageDetail);

        await uploadShopifyCollectionImage({
            collectionId: collection.shopifyId,
            imageBase64: imageData,
            imageFileName: imageFileName,
            downloadUrl: imageDetail?.downloadUrl,
            mimeType: 'image/jpeg',
            title: collection.title + ' | Leafy Orb',
        });

        setSaveInProgress(false);
    }

    return (
        <>
            <button
                className="button-sky px-3 py-2 mr-2"
                onClick={uploadCollectionImage}>
                Upload Collection Image
            </button>
        </>
    )
}

export default UpdateShopifyCollectionImage
